module.exports = "/_next/static/images/img__main_touch-54e40f6a4293b7ec7a3cb48841f9e023.png";